import type { WorkflowActivity } from "../../../../../api/types/workflowTypes";
import RunChecklistActivityContent from "./RunChecklistActivityContent";

interface Props {
  workflowId: string;
  workflowActivity: WorkflowActivity;
}

const runChecklistActivityTypes: WorkflowActivity["type"][] = [
  "RunInvestorCapitalCallChecklist",
  "RunInvestorDistributionChecklist",
  "RunInvestorTransferChecklist",
  "RunNavPreparationChecklist",
];

const WorkflowActivityTypeSpecificContent = ({ workflowId, workflowActivity }: Props) => {
  if (runChecklistActivityTypes.includes(workflowActivity.type)) {
    return <RunChecklistActivityContent workflowId={workflowId} workflowActivity={workflowActivity} />;
  }

  return null;
};

export default WorkflowActivityTypeSpecificContent;
